import { SVGProps } from 'react';

export function ChatBubbleMultipleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3 2.8H11.9V9.1H2.8V10.5C2.8 10.885 3.115 11.2 3.5 11.2H11.2L14 14V3.5C14 3.115 13.685 2.8 13.3 2.8ZM10.5 7V0.7C10.5 0.315 10.185 0 9.8 0H0.7C0.315 0 0 0.315 0 0.7V10.5L2.8 7.7H9.8C10.185 7.7 10.5 7.385 10.5 7Z"
        fill="currentcolor"
      />
    </svg>
  );
}
